import { z } from 'zod';
import type { ProjectDoc, SpectrogramMapItem } from '@ledium/types';
import { nameSchema, descriptionSchema, idRefSchema } from './primitives.js';

const spectrogramMapItemSchema: z.ZodType<SpectrogramMapItem> = z.object({
    lightRecipeId: idRefSchema,
    spectrumMixId: z.string().nullable()
});

type ProjectInput = Omit<ProjectDoc, '_id' | 'locked' | 'linked' | 'running' | 'startTime' | 'pauseData' | 'errorCode' | 'timeDelay'> & { timeDelay?: number };

export const projectSchema: z.ZodType<ProjectInput> = z.object({
    name: nameSchema,
    description: descriptionSchema,
    zoneId: z.string().min(1),
    recipeId: idRefSchema,
    spectrogramMap: z.array(spectrogramMapItemSchema),
    timeDelay: z.number().int().min(0).optional()
});
